import React from 'react'

import Navbar from '../components/navbar'
import Feature from '../components/feature'
import AboutOne from '../components/about-one'
import Blog from '../components/blog'
import Footer from '../components/footer'
import ScrollToTop from '../components/scroll-to-top'
import Cta from '../components/cta'
import Faq from '../components/faq'
import Team from '../components/team'
import HomeBanner from '../components/home-banner'

import faqImg from '../assets/images/faqs.svg'

export default function Index() {
  return (
    <>
    <Navbar/>

    <HomeBanner/>

    <section className="section overflow-hidden">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col">
                    <div className="section-title text-center mb-4 pb-2">
                        <h4 className="title mb-3">Our Features</h4>
                        <p className="text-muted para-desc mb-0 mx-auto">We've cultivated a dynamic space where creativity seamlessly intertwines with strategy and innovation.</p>
                    </div>
                </div>
            </div>
            <Feature/>
        </div>

        <div className="container mt-100 mt-60">
            <AboutOne/>
        </div>
    </section>

    <Cta/>

    <section class="section">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-12">
                    <div class="section-title text-center mb-4 pb-2">
                        <h4 class="title mb-3">Our Minds</h4>
                        <p class="text-muted para-desc mx-auto mb-0">We've cultivated a dynamic space where creativity seamlessly intertwines with strategy and innovation.</p>
                    </div>
                </div>
            </div>

            <Team/>
        </div>

        <div class="container mt-100 mt-60">
            <div class="row align-items-center">
                <div class="col-lg-6 col-md-6">
                    <div class="position-relative">
                        <img src={faqImg} class="img-fluid" alt=""/>

                        <div class="modern-app-round round-small"></div>
                    </div>
                </div>

                <div class="col-lg-6 col-md-6 mt-4 mt-md-0 pt-2 pt-md-0">
                    <div class="section-title mb-4 ms-lg-3">
                        <h4 class="title mb-3">Frequently Asked Questions</h4>
                        <p class="text-muted para-desc mb-4">We've cultivated a dynamic space where creativity seamlessly intertwines with strategy and innovation.</p>
                    
                        <Faq/>
                    </div>
                </div>
            </div>
        </div>

        <div class="container mt-100 mt-60">
            <div class="row justify-content-center">
                <div class="col-12">
                    <div class="section-title text-center mb-4 pb-2">
                        <h4 class="title mb-3">Blog Or News</h4>
                        <p class="text-muted para-desc mx-auto mb-0">We've cultivated a dynamic space where creativity seamlessly intertwines with strategy and innovation.</p>
                    </div>
                </div>
            </div>

            <Blog/>
        </div>
    </section>

    <Footer/>
    <ScrollToTop/>
    </>
  )
}
